import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from "lodash";
import { Request } from "./request";
import { URLS } from "../constants/url.constants";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor(
    private request: Request,
    private http: HttpClient,
  ) {
  }


  getUsersList(event): Observable<any> {

    if(event.direction == 'desc'){
      event.direction = 2;
    }
    else{
      event.direction = 1;
    }

    let url = URLS.users.getUsersList+'?limit='+event.pageSize+'&page='+(event.pageIndex+1)+'&searchkey='+event.filterValue+'&order_by='+event.active+'&dir='+event.direction+'&role='+event.role;
    return this.request.getApi(url);
  }

  saveUsers(values): Observable<any> {
    let url = URLS.users.saveUsers;
    return this.request.postApi(url, values);
  }

  editUsers(id, values): Observable<any> {
    let url = URLS.users.editDeleteUsers;
    url = _.replace(url, "{id}", id);
    return this.request.putApi(url, values);
  }

  deleteUsers(data): Observable<any> {
    let url = URLS.users.editDeleteUsers;
    url = _.replace(url, "{id}", data.id);
    return this.request.deleteApi(url);
  }

  getUsersInfo(id): Observable<any> {
    let url = URLS.users.editDeleteUsers;
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }

  userDetails(id): Observable<any> {
    let url = URLS.auth.userDetails;
    url = _.replace(url, "{id}", id);
    return this.request.getApi(url);
  }

  forgotPassword(values): Observable<any> {
    let url = URLS.auth.forgotpassword;
    return this.request.postApi(url, values);
  }
}
